<template>
  <div class="winners-list">
    <div class="top">
      <div class="top-content">
        <h1>上月中奖名单</h1>
        <p>每月对完成问卷的用户随机抽取20名送188红包</p>
      </div>
    </div>
    <div class="container">
      <div class="win-main">
        <ul>
          <li class="win-list">
            <div>
              <span class="lis-img-t">头像</span>
              <span class="list-name">用户昵称</span>
              <span class="list-tel">手机号</span>
            </div>
          </li>
          <li class="win-list">
            <div v-for="(item, index) in winnerList" :key="index">
              <span class="list-img">
                <img
                  :src="item.touxiang ? item.touxiang : require('@/assets/logo/logo.svg')"
                  :class="{'default-avatar': !item.touxiang}"
                  alt=""
                  @error="$event.target.src = require('@/assets/logo/logo.svg');$event.target.classList.add('default-avatar')">
              </span>
              <span class="list-name">{{item.nickname}}</span>
              <span class="list-tel">{{item.telphone}}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetwinner } from "../../request/API";
export default {
  data() {
    return {
      id: '',
      winnerList: []
    }
  },
  created() {
    this.id = this.$route.query.id
    apiGetwinner({id: this.id}).then(res => {
      this.winnerList = res.data
    })
  },
}
</script>

<style lang="less">
.winners-list{
  min-height: 100vh;
  box-sizing: border-box;
  background: #F7F5F2;

  .top{
    width: 100vw;
    height: 310px;
    position: relative;
    overflow: hidden;
    background:
      radial-gradient(circle at 18% 18%, rgba(255, 255, 255, 0.28) 0, rgba(255, 255, 255, 0) 28%),
      linear-gradient(135deg, #1A1D24 0%, #F0EDE8 48%, #1A1D24 100%);

    &::before,
    &::after{
      content: '';
      position: absolute;
      border-radius: 4px;
      pointer-events: none;
    }

    &::before{
      width: 360px;
      height: 360px;
      right: 11%;
      top: -178px;
      background: rgba(255, 255, 255, 0.14);
    }

    &::after{
      width: 220px;
      height: 220px;
      left: 12%;
      bottom: -112px;
      background: rgba(255, 255, 255, 0.1);
    }

    .top-content{
      position: relative;
      z-index: 1;
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      padding-top: 72px;
      box-sizing: border-box;
      color: #fff;
      text-align: center;

      h1{
        margin: 0;
        font-size: 38px;
        line-height: 54px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        letter-spacing: 0;
      }

      p{
        margin: 12px 0 0;
        font-size: 18px;
        line-height: 28px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.86);
      }
    }
  }
  .container{
    width: 1200px;
    margin:  0 auto;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.10);
    position: relative;
    top: -74px;
    padding-top: 20px;
    padding-bottom: 100px;
    .win-main{
      width: 989px;
      margin: 0 auto;
      .win-list{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #a5abb8;
        border-bottom: 1px #EDEBEB solid;
        div{
          width: 367px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 80px;
          .lis-img-t{
            text-indent: 10px;
          }
          .list-img{
            width: 50px;
            height: 50px;
            // border: 1px #000 solid;
            border-radius: 50%;
            img{
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
            }
            .default-avatar{
              padding: 8px;
              object-fit: contain;
              box-sizing: border-box;
              background: var(--bg-tag, #F0EDE8);
            }
          }
          .list-name{
            width: 96px;
            text-overflow:ellipsis;
            overflow:hidden;
            white-space:nowrap;
          }
          .list-tel{
            width: 100px;
          }
        }
        
      }
    }
  }
  @media screen and (max-width: 1300px) {
    .top {
      .top-content {
        width: 95vw;
      }
    }
    .container {
      width: 95vw;
    }
  }
  @media screen and (max-width: 1100px) {
    .top{
      height: 248px;

      .top-content{
        padding-top: 58px;

        h1{
          font-size: 32px;
          line-height: 46px;
        }

        p{
          margin-top: 10px;
          font-size: 17px;
          line-height: 26px;
        }
      }
    }
    .container {
      top: -44px;
      .win-main{
        width: 85vw;
      }
    }
  }
  @media screen and (max-width: 500px) {
    .top{
      height: 232px;

      &::before{
        right: -120px;
        top: -190px;
      }

      &::after{
        left: -90px;
        bottom: -130px;
      }

      .top-content{
        padding-top: 54px;

        h1{
          font-size: 27px;
          line-height: 38px;
        }

        p{
          width: 86vw;
          margin: 10px auto 0;
          font-size: 15px;
          line-height: 24px;
        }
      }
    }
    .container {
      top: -44px;
      padding-top: 0;
      .win-main{
        .win-list{
          div{
            width: 75vw;
            height: 70px;
          }
        }
      }
    }
  }
}
</style>
